<template>
  <router-link :to="{ path: '/airalo_simcard/' + airalo_simcard.iccid }" class="airalo_simcard_item link">
    <tr>
      <td :data-label="translate('airalo.airalo_simcard_id')">
        {{ airalo_simcard.airalo_simcard_id }}
      </td>
      <td :data-label="translate('airalo.active')">
        <span class="badge" :style="'background-color: ' + active_airalo(airalo_simcard.active).color">
          {{ translate("airalo.filter." + active_airalo(airalo_simcard.active).title) }}
        </span>
      </td>
      <td :data-label="translate('airalo.package_id')">
        {{ airalo_simcard.package_id }}
      </td>
      <td :data-label="translate('airalo.order_id')">
        {{ airalo_simcard.order_id }}
      </td>
      <td :data-label="translate('airalo.iccid')" @click.prevent="">
        <router-link :to="'/simcard_devices_list?&msisdn_imsi_iccid=' + airalo_simcard.iccid">
          {{ airalo_simcard.iccid }}
        </router-link>
        <span class="mdi mdi-content-copy" @click="copy_iccid(airalo_simcard.iccid)" />
      </td>
      <td :data-label="translate('airalo.apn_value')">
        {{ airalo_simcard.apn_value }}
      </td>
      <td :data-label="translate('airalo.is_unlimited')" class="w60">
        {{ airalo_simcard.is_unlimited === 1 ? "Да" : "" }}
      </td>
      <td :data-label="translate('airalo.expires')">
        {{ expiry }}
      </td>
      <td :data-label="translate('airalo.purchased')">
        {{ get_date(airalo_simcard.ts_create) }}
      </td>
      <td :data-label="translate('airalo.ts_update')">
        {{ (get_date(airalo_simcard.ts_update)) }}
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'AiraloSimcardListItem',
  components: {
  },
  props: ["airalo_simcard"],
  data () {
    return {
      actives: [
        {
          "id": 0,
          "title": "not_active",
          "color": "orange"
        },
        {
          "id": 1,
          "title": "active",
          "color": "green"
        }
      ]
    }
  },
  computed:{
    expiry(){
      return this.get_date(+new Date(this.airalo_simcard.expired_at) / 1000)
    }
  },
  methods: {
    copy_iccid(string){
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    active_airalo(active_id){
      let active = this.actives.find((item) => {
        if (item.id === active_id) return item
      })
      return active ? active : { color: "red", title: "Not Found" }
    },
  }
}
</script>

<style lang="scss" scoped>
.airalo_simcard_item{
  cursor: pointer;
  color: #252422;
  &:hover{
    tr{
      background-color: #eee;
    }
  }
  td{
    overflow: hidden;
    vertical-align: middle;
    &.sum{
      text-align: right;
      padding-right: 20px;
    }
  }
}
</style>
